import React from "react";
import cx from "classnames";

import useFeatures from "../../hooks/useFeatures";
import { Icon, Tooltip } from "@showitinc/showit-wc";
import styles from "./BetaLabel.module.css";

const BetaLabel = () => {
  const { activeFeatures, isBeta, betaMessage } = useFeatures();

  return isBeta ? (
    <Tooltip position="bottom-center" className={cx(...activeFeatures)}>
      <div className={styles.root}>
        Beta <Icon type="warning" />
      </div>
      <div slot="content">{betaMessage}</div>
    </Tooltip>
  ) : null;
};

export default BetaLabel;
